import { fade, makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.primary.main,
    padding: '20px 0',

    [theme.breakpoints.down('xs')]: {
      textAlign: 'center',
      padding: '20px 0',
    },
  },

  logo: {
    [theme.breakpoints.down('xs')]: {
      // small breathing room above links
      marginBottom: 8,
    },
  },

  links: {
    [theme.breakpoints.down('xs')]: {
      marginTop: 6,
      marginBottom: 0,
    },
  },

  topRow: {
    marginBottom: 0,
  },

  topRowInner: {
    [theme.breakpoints.up('sm')]: {
      flexWrap: 'nowrap',
      width: '100%',
      justifyContent: 'space-between',
    },
  },

  desktopLinks: {
    display: 'flex',
    justifyContent: 'flex-start',
    marginLeft: 0,
    marginRight: 72,
    transform: 'translateY(-2px)',
  },

  list: {
    alignItems: 'center',
    display: 'flex',
    flexWrap: 'nowrap',
    padding: '0',

    [theme.breakpoints.down('xs')]: {
      display: 'block',
      justifyContent: 'center',
      padding: '0.5rem 0',
    },
  },

  listItem: {
    color: theme.palette.common.white,
    display: 'inline-block',
    fontSize: theme.typography.fontSize,
    padding: '0',
    textAlign: 'center',

    '& > *': {
      margin: 0,
    },

    [theme.breakpoints.up('sm')]: {
      width: 'auto',
    },

    [theme.breakpoints.down('xs')]: {
      marginBottom: 16,
      textAlign: 'left',
    },
  },

  icon: {
    color: theme.palette.common.white,
    fontSize: 30,
  },

  copyright: {
    color: fade(theme.palette.common.white, 0.4),
    [theme.breakpoints.down('xs')]: {
      textAlign: 'left',
    },
  },

  contactDetails: {
    color: fade(theme.palette.common.white, 0.4),
    marginTop: 2,
    marginBottom: 5,
    [theme.breakpoints.down('xs')]: {
      textAlign: 'left',
    },
  },

  social: {
    [theme.breakpoints.down('xs')]: {
      textAlign: 'center',
    },
  },

  divider: {
    margin: '0 clamp(8px, 1.2vw, 18px)',
    background: theme.palette.common.white,
  },
}));
